export const   WHITE_LIST_APIS = [
    'MarketDataResearchDocuments/getList',
    'Salutations',
    'Organizations',
    'TechDomains',
    'EmployeeSizes',
    'ItBudgets',
    'Revenues',
    'Industries',
    'Countries',
    'users/:id'



];



// WEBPACK FOOTER //
// ./src/app/shared/http-interceptors/whitelisted-apis.ts